import React from "react";
import { TECH_STACK } from "../data/content";
import "../styles/product.css";
import attendance from "../assets/screenshots/attendance-check.gif";

function TechStackSection() {
  return (
    <section className="product section" id="tech-stack">
      <div className="container">
        <div className="product-grid">
          <div className="product-copy">
            <span className="eyebrow">
              <span className="eyebrow-dot" aria-hidden="true" />
              Product overview
            </span>
            <h2 className="section-title">
              One connected system for attendance and HR
            </h2>
            <p className="section-subtitle product-lead">
              MPeoples HRMS is a mobile-based Human Resource Management
              System designed to simplify and digitize employee attendance
              and day-to-day HR activities. It gives employees and
              organizations a centralized platform for managing attendance
              and HR-related activities — reducing dependency on manual
              attendance processes with digital check-in and check-out,
              selfie-based verification, location tracking, leave and
              permission management, holiday information, monthly
              attendance tracking, payroll and payslip access, and report
              generation.
            </p>
            <p className="product-note">
              A web-based Admin Dashboard, complements
              the mobile application — allowing HR and management to
              centrally administer the system.
            </p>
          </div>

          <div className="product-stack">
            <div className="hero-phone" style={{height:"100%"}}>
              <div className="hero-phone-notch" aria-hidden="true" />
              <img
                src={attendance}
                alt="MPeoples HRMS check-in screen"
                className="hero-phone-screen"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TechStackSection;
